import { UserAnalyticsResultModel } from '../../Login/models/UserModel';
import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import UserModel from '../../Login/models/UserModel';
import { OrderDirection } from '../../Datatable/OrderDirection';

interface userManagementInputState {
    input: UserModel,
    users: UserModel[],
    selectedIndex: number,
    selectedUserId: number,
    triggerRefreshInput: number,
    inputExpand: boolean,
    triggerRefreshTable: number,
    orderBy: string,
    orderDirection: OrderDirection
}

const initialState: userManagementInputState = {
    input: {
        id: -1,
        email: "",
        userGroup: "",
        displayName: "",
        isLocked: false,
        password: "",
        workingEmail: "",
        emailDisplayName: "",
        lastLogin: "",
        analytics: {
        } as UserAnalyticsResultModel
    } as UserModel,
    users: [],
    selectedIndex: -1,
    selectedUserId: -1,
    triggerRefreshInput: 0,
    inputExpand: true,
    triggerRefreshTable: 0,
    orderBy: "updatedDate",
    orderDirection: OrderDirection.Desc,
}

export const UserManagementSlice = createSlice({
    name: "UserManagement",
    initialState,
    reducers: {
        resetUserInput: (state) => {
            state.input = initialState.input;
        },
        setUserInput: (state, action: PayloadAction<UserModel>) => {
            state.input = action.payload;
        },
        setEmail: (state, action: PayloadAction<string>) => {
            state.input.email = action.payload;
        },
        setUserGroup: (state, action: PayloadAction<string>) => {
            state.input.userGroup = action.payload;
        },
        setDisplayName: (state, action: PayloadAction<string>) => {
            state.input.displayName = action.payload;
        },
        setWorkingEmail: (state, action: PayloadAction<string>) => {
            state.input.workingEmail = action.payload;
        },
        setEmailDisplayName: (state, action: PayloadAction<string>) => {
            state.input.emailDisplayName = action.payload;
        },
        setIsLocked: (state, action: PayloadAction<boolean>) => {
            state.input.isLocked = action.payload;
        },
        setPassword: (state, action: PayloadAction<string>) => {
            state.input.password = action.payload;
        },
        setUsers: (state, action: PayloadAction<UserModel[]>) => {
            state.users = action.payload;
        },
        setSelectedUserIndex: (state, action: PayloadAction<number>) => {
            state.selectedIndex = action.payload;
        },
        setSelectedUserId: (state, action: PayloadAction<number>) => {
            state.selectedUserId = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
        setInputExpand: (state, action: PayloadAction<boolean>) => {
            state.inputExpand = action.payload;
        },
        setTriggerRefreshTable: (state, action: PayloadAction<number>) => {
            state.triggerRefreshTable = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.orderBy = action.payload;
        },
        setOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.orderDirection = action.payload;
        },
    }
});

export const userManagementSelector = createSelector(
    (state: RootState) => state.userManagement,
    (data) => data
);

export const {
    resetUserInput,
    setUserInput,
    setEmail,
    setUserGroup,
    setDisplayName,
    setWorkingEmail,
    setEmailDisplayName,
    setIsLocked,
    setPassword,
    setUsers,
    setSelectedUserIndex,
    setSelectedUserId,
    setInputExpand,
    setTriggerRefreshTable,
    setOrderBy,
    setOrderDirection
} = UserManagementSlice.actions;

export default UserManagementSlice.reducer;